import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../routers/AuthProvider";
import { useForm } from "../../hooks/useForm";
import backArrowIcon from "../../assets/img/back-arrow.png";
import "../../assets/css/common.css";
import axios from "axios";
import { API_URL } from "../../utils/constant";
import AsyncSelect from "react-select/async";
import { Toast } from "../../components/ToastComponent";

const CreateAdjustment = () => {
  const backPath = "/warehouse/adjustment/list";
  const {
    handleInputChange,
    formData,
    submitForm,
    setFormData,
    setError,
    error,
  } = useForm();
  useEffect(() => {
    if (error) {
      Toast.fire({
        title: error,
        icon: "error",
      });
    }
  }, [error]);
  const navigate = useNavigate();
  const { user, setLoading } = useAuth();
  const [warehouses, setWarehouses] = useState([]);
  const [warehouseLoading, setWarehouseLoading] = useState(false);
  const onSubmit = (e) => {
    setLoading(true);
    e.preventDefault();
    const data = {
      product_id: product, // now product_id is defined
      ...formData,
    };
    submitForm(
      "POST",
      "/adjustment",
      data,
      () => {
        navigate(backPath);
      },
      "Successfully Created"
    );
  };

  const [product, setProduct] = useState();
  const loadOptions = (inputValue) => {
    return axios
      .get(API_URL + "/product/no-price", {
        withCredentials: true,
      })
      .then((response) => {
        return response.data.data.filter((option) =>
          option.product_name.toLowerCase().includes(inputValue.toLowerCase())
        );
      });
  };

  const [units, setUnits] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const handleProductChange = (option) => {
    setWarehouses([]);
    setUnits([]);
    setFormData((prev) => ({
      ...prev,
      warehouse_id: "",
      sku_unit_id: "",
    }));

    if (!option) {
      setSelectedProduct(null);
      setProduct(undefined);
      return;
    }

    setSelectedProduct(option.product_id);
    setProduct(option.product_id);
    setWarehouseLoading(true);

    axios
      .get(
        `${API_URL}/adjustment/product-units?product_id=${option.product_id}`,
        {
          withCredentials: true,
        }
      )
      .then((response) => {
        setUnits(response.data.data);
      });

    axios
      .get(
        `${API_URL}/adjustment/warehousebyproduct?product_id=${option.product_id}`,
        {
          withCredentials: true,
        }
      )
      .then((response) => {
        setWarehouses(response.data.data || []);
      })
      .finally(() => {
        setWarehouseLoading(false);
      });
  };

  return (
    <div className="sub-page-layout-1">
      <Link className="back-to-page" to={backPath}>
        <img src={backArrowIcon} />
        Back
      </Link>
      <div className="container" style={{ height: "auto" }}>
        <h1 className="sub-page-title">Create New Adjustment</h1>
        <div className="form-container">
          <form
            onSubmit={onSubmit}
            className="form flex flex-col justify-between w-full"
          >
            <h2 className="sub-title mb-8">Adjustment Information</h2>
            <div className="grid grid-cols-2 gap-9">
              <div className="grow">
                <label className="x-label input-required">Product Name</label>
                <AsyncSelect
                  defaultOptions
                  cacheOptions
                  loadOptions={loadOptions}
                  isSearchable={true}
                  getOptionLabel={(option) => option.product_name}
                  getOptionValue={(option) => option.product_id}
                  onChange={handleProductChange}
                  isClearable
                  menuPortalTarget={document.body}
                  styles={{
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      borderColor: "#1b1b1b66",
                      minHeight: "50px",
                      zIndex: 10,
                    }),
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                />
              </div>
              <div className="grow">
                <label className="x-label input-required">Warehouse Name</label>
                <div className="dd-container">
                  <select
                    type="text"
                    name="warehouse_id"
                    className="x-input dropdown"
                    value={formData.warehouse_id || ""}
                    required
                    onChange={handleInputChange}
                    disabled={!selectedProduct || warehouseLoading}
                  >
                    <option value="" disabled>
                      {warehouseLoading
                        ? "Loading..."
                        : selectedProduct
                        ? "Select"
                        : "Select product first"}
                    </option>
                    {warehouses &&
                      warehouses.map((warehouse, index) => (
                        <option
                          key={index}
                          value={warehouse.warehouse_id}
                        >
                          {warehouse.warehouse_name}
                        </option>
                      ))}
                  </select>
                </div>
              </div>

              <div className="grow">
                <label className="x-label input-required">Quantity</label>
                <input
                  inputMode="numeric"
                  pattern="[0-9]*"
                  min="0"
                  type="number"
                  required
                  name="quantity"
                  onChange={handleInputChange}
                  className="x-input"
                />
              </div>

              <div className="grow">
                <label className="x-label input-required">SKU</label>
                <div className="dd-container">
                  <select
                    name="sku_unit_id"
                    value={formData.sku_unit_id || ""}
                    onChange={handleInputChange}
                    disabled={!selectedProduct}
                    className="x-input dropdown"
                  >
                    <option value="" disabled>
                      Select
                    </option>
                    {units.map((item, index) => (
                      <option key={index} value={item.unit_id}>
                        {item.unit_name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="grow">
                <label className="x-label input-required">Method</label>
                <div className="dd-container">
                  <select
                    type="text"
                    name="adjustment_method"
                    className="x-input dropdown"
                    defaultValue=""
                    required
                    onChange={handleInputChange}
                  >
                    <option value="" disabled>
                      Select
                    </option>
                    <option value="IN">IN</option>
                    <option value="OUT">OUT</option>
                  </select>
                </div>
              </div>
              <div className="grow">
                <label className="x-label input-required">
                  Adjustment Date
                </label>
                <input
                  type="date"
                  required
                  name="adjustment_date"
                  onChange={handleInputChange}
                  className="x-input"
                />
              </div>

              <div className="grow">
                <label className="x-label">Remark</label>
                <input
                  type="text"
                  name="remark"
                  onChange={handleInputChange}
                  className="x-input"
                />
              </div>
            </div>
            <div className="mt-8 form-btn-group">
              {/* {error ? <span className='w-full block text-lg text-red-500 text-right'>{error}</span> : ''} */}
              <div className="flex justify-end gap-5 mt-5">
                <Link to={backPath} className="white-btn">
                  Cancel
                </Link>
                <button type="submit" className="gold-btn">
                  Create
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CreateAdjustment;
